import axios from 'axios';
import * as Sentry from '@sentry/react';
import { withIdToken } from 'utils/server';
import { apiBaseUrl } from './baseUrl';
export * from './TakeAway';

declare module 'axios' {
  export interface AxiosRequestConfig {
    expectedErrorStatuses?: number[];
  }
}

const server = withIdToken(
  axios.create({
    baseURL: apiBaseUrl,
    timeout: 15000,
    headers: { 'X-Custom-Header': 'dashboard' },
  }),
);

server.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const expectedErrorStatuses: number[] = error.config?.expectedErrorStatuses ?? [];
    if (status !== 401 && status !== 403 && !expectedErrorStatuses.includes(status)) {
      Sentry.captureException(error, {
        tags: {
          api_endpoint: error.config?.url,
          http_status: status ?? 'network_error',
        },
        contexts: {
          http: {
            method: error.config?.method?.toUpperCase(),
            url: error.config?.url,
            status_code: status,
          },
        },
      });
    }
    return Promise.reject(error);
  },
);

export default server;
